<template>
  <ConfirmDialog ref="confirm" />

  <v-dialog persistent width="300" :model-value="!!loadingDialogText" :scrim="false">
    <v-card color="primary" dark>
      <v-card-text>
        {{ loadingDialogText ? $t(loadingDialogText) : loadingDialogText }}
        <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-container fluid class="pa-0">
    <v-form ref="form">
      <v-row>
        <v-col>
          <div class="searchItems text-start">
            <slot name="searchItems"></slot>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="buttons">
            <v-btn
              class="searchButton resetButton"
              elevation="0"
              @click="resetForms"
            >
              {{ $t('Сбросить') }}
            </v-btn>
            <v-btn
              color="primary"
              class="searchButton bg-primary"
              elevation="0"
              @click="$emit('search')"
            >
              {{ $t('Найти') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { toast } from '@/lib/toast';
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";

export default {
  name: 'ExtendedSearch',
  components: { ConfirmDialog },
  props: {
    tableModel: {
      type: Object,
      required: true,
    },
    searchParams: {
      type: Object,
      required: true,
    },
    search: {
      type: Function,
    },
    resetSearch: {
      type: Function,
    },
  },
  methods: {
    async resetForms() {
      const approve = await this.$refs.confirm.open(
          'Сбросить фильтры',
          'Вы действительно хотите сбросить все фильтры? Введённые значения будут удалены.',
      );

      if (approve) {
        try {
          this.loadingDialogText = 'Сбрасываются фильтры';
          this.$refs.form.reset();
          this.$emit('resetSearch');
        } catch (e) {
          toast.error(e.message);
        }
        this.loadingDialogText = null;
      }
    },
  }
}
</script>
<style scoped>
.searchItems {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

:slotted(.searchItem) {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  align-self: stretch;
  margin-top: 20px;
}

:slotted(.searchItem) > .searchItemTitle {
  color: rgb(var(--black-color));
  font-family: var(--primary-font-family-name);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.buttons {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  .searchButton {
    display: flex;
    border-radius: 6px;
    border: 1px solid rgb(var(--button-border-color));
    font-family: var(--primary-font-family-name);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    text-transform: none;
    letter-spacing: normal;
    height: auto;
    padding: 10px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .resetButton {
    border-radius: 6px;
    border: 1px solid rgb(var(--intec-primary-color));
    color: rgb(var(--intec-primary-color));
    background-color: transparent;
  }
}

@media screen and (width < 1600px) {
  .buttons {
    flex-wrap: wrap;

    .searchButton {
      width: 100%;
    }
  }
}
</style>
